export const viewTypeRegexMap = {
	vdp: '(?:^AUTO_.*_DETAILS|.*_DETAILS.*)$',
	vlp: '.*(?:INVENTORY_LISTING|INVENTORY_FEATURED|INVENTORY_SEARCH|_INVENTORY|SMARTBROWSE|FACETBROWSE_AJAX).*',
	contact: '.*(?:CONTACT|QUICK_QUOTE|CARFINDER).*',
	error: '.*404.*',
	about: '.*(?:ABOUT|BLOG|EMPLOYMENT|NEWS|STAFF|TESTIMONIALS).*',
	comparison: '.*(?:COMPARE|FAVORITES).*',
	directions: '.*(?:DIRECTIONS|LOCATIONS).*',
	finance: '.*FINANCE.*',
	specials: '.*(?:INCENTIVES|SPECIALS).*',
	home: 'INDEX',
	parts: '.*PARTS.*',
	service: '.*(?:SERVICE|BODYSHOP).*',
	showroom: '.*SHOWROOM.*',
	other: ''
};

export default () => {
	if (window.DDC.dataLayer.page.trackingTags?.pageType)
		return window.DDC.dataLayer.page.trackingTags.pageType;
	const alias = window.DDC.dataLayer.page.pageInfo.pageName;
	return Object.keys(viewTypeRegexMap).find((pageType) =>
		alias.match(viewTypeRegexMap[pageType])
	);
};
